import React, { useState } from 'react';
import { NumberInput } from 'carbon-components-react';

const CustomSubformNumericInput = props => {
  const [value, setValue] = useState(props.formData || 0);

  const onChange = event => {
    if (event.type !== 'click') {
      setValue(parseInt(event.target.value));
      props.onChange(parseInt(event.target.value));
    }
  };

  const onClick = event => {
    let auxVal = 0;
    if (value) {
      auxVal = value;
    }
    if (event.target.title === 'Increment number') {
      auxVal++;
    } else if (event.target.title === 'Decrement number') {
      auxVal--;
    }
    setValue(auxVal);
    props.onChange(auxVal);
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        paddingTop: 10,
        marginTop: 14,
        alignItems: 'flex-start'
      }}
    >
      <NumberInput
        id={props.idSchema.$id}
        invalid={false}
        invalidText='A valid value is required'
        label={props.schema.title}
        value={value}
        onChange={onChange}
        onClick={onClick}
        disabled={props.schema.readOnly}
        style={{ background: 'white', width: '100%', minWidth: '200px' }}
      />
    </div>
  );
};

export default CustomSubformNumericInput;
